<template>
    <div element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.body="fullscreenLoading">
        <el-container>
            <el-header>
                <nav-header></nav-header>
            </el-header>

            <el-container class="top-marg">
                <el-main>
                    <el-breadcrumb class="app-breadcrumb" separator="/">
                        <transition-group name="breadcrumb">
                            <el-breadcrumb-item v-for="(item, index)  in levelList" :key="item.path" v-if='item.meta.title'>
                                <span v-if='item.redirect==="noredirect"||index==levelList.length-1' class="no-redirect">{{$t(item.meta.title)}}</span>
                                <router-link v-else :to="item.redirect||item.path">{{$t(item.meta.title)}}</router-link>
                            </el-breadcrumb-item>
                        </transition-group>
                        
                        <!-- <div class="clock-main">
                            <a href="javascript:void(0);" class="help" @click="runTour" v-if="showHelp">Help <i class="el-icon-question"></i></a>
                            <vue-clock />
                        </div> -->
                    </el-breadcrumb>
        
                      <el-alert style="display: flex;flex-wrap: wrap;align-items: center;margin-top: 20px; font-size: 12px;"  v-if="$store.state.config.user.is_password == 0"  title=""  type="warning" effect="dark"> 
                      <i class="el-alert__icon el-icon-warning is-big"></i> <span>{{ $t('You are logged in with the auto generated credentials.') }} <router-link to="/change-password">{{ $t('Click Here') }}</router-link> {{ $t('to Change password.') }}</span> 
                      </el-alert>
                    <!-- <el-alert style="margin-top: 20px" v-if="$store.state.config.user.role_slug.indexOf('fachstellen') >= 0 && $store.state.config.user.is_password == 0"
                        title="warning alert"
                        type="warning"
                        description="<h1>more text description</h1>"
                        show-icon
                        effect="dark">
                    </el-alert> -->
                    <div class="page-content-body">
                        <router-view :key="$route.fullPath"></router-view>
                    </div>
                </el-main>
            </el-container>
            <el-footer height="">
                <bottom-footer></bottom-footer>
            </el-footer>
            <el-dialog :visible.sync="footerDialogvisible" title="Hello world">
                <div v-html="privacy_policy"></div>
            </el-dialog>   
        </el-container>
    </div>
</template>

<script>
    import NavHeader from "./NavHeader/NavHeader";
    import BottomFooter from "./BottomFooter/BottomFooter";
    import VueClock from "./Widgets/Clock/Clock";
    export default {
        components: {
            "nav-header": NavHeader,
            "bottom-footer": BottomFooter,
            "vue-clock": VueClock
        },
        data() {
            return {
                fullscreenLoading: false,
                levelList: null,
                showHelp: false,
                runHelpTour: false,
                footerDialogvisible: false,
                privacy_policy: null
            };
        },
        watch: {
            $route() {
                this.getBreadcrumb()
            }
        },
        methods: {
            getBreadcrumb() {
                let matched = this.$route.matched.filter(item => item.meta.title)
                const first = matched[0]
                if (first && first.name !== 'dashboard' && first.meta.title != 'Dashboard') {
                    matched = [{
                        path: '/dashboard',
                        meta: {
                            title: 'Dashboard'
                        }
                    }].concat(matched)
                }
                this.levelList = matched

                // Code to show Help button
                if((this.$store.state.config.user.role_slug.indexOf('fachstellen') >= 0 && this.$route.name === 'Dashboard') || 
                    (this.$store.state.config.user.role_slug.indexOf('club') >= 0 && this.$route.name === 'CaseVoting') ||
                    (this.$store.state.config.user.role_slug.indexOf('organization') >= 0 && this.$route.name === 'Dashboard')) {
                    this.showHelp = true
                } else {
                    this.showHelp = false;
                }
            },
            runTour() {
                serverBus.$emit('runHelpTour', this.showHelp);
            }
        },
        mounted() {
            serverBus.$on("loader", text => {
                this.fullscreenLoading = text;
            });
            serverBus.$on("showHelp", status => {
                this.showHelp = status;
            });
            serverBus.$on("showPrivacyPopup", status => {
                request({
                    url: "general-information",
                    method: "GET"
                }).then(response => {
                    this.privacy_policy = response.data.data.privacy_policy;
                    this.footerDialogvisible = status;
                });
            });
            this.getBreadcrumb()
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Layout.vue